import moment from 'moment';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import FlightTakeoffOutlinedIcon from '@material-ui/icons/FlightTakeoffOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { displayDateFormatShort } from '../../../constants';
import { PLANNER_COLORS } from '../shared_components';
import { STATUS_IDS } from './constants';

export const formatPlanDate = (date) => (date ? moment(date).format(displayDateFormatShort) : '--');


export const buildPlanPayload = (formData) => ({
  name: formData?.name,
  project_type: formData?.project_type ? formData?.project_type.id : undefined,
  inspection_type: formData?.inspection_type ? formData?.inspection_type.id : undefined,
  lessor_id: formData?.lessor ? formData?.lessor.id : undefined,
  lessee_id: formData?.lessee ? formData?.lessee.id : undefined,
  location: formData?.location,
  client: formData?.client ? formData?.client?.id : undefined,
  expected_asset_count: formData?.expected_asset_count || null,
  planned_start_date: formData?.planned_start_date || undefined,
  planned_end_date: formData?.planned_end_date || undefined,
  stage_template: formData?.stage_template ? formData?.stage_template.id : undefined,
  current_stage: formData?.current_stage ? formData?.current_stage.id : undefined,
  report_status_records: formData?.report_status_records ? formData?.report_status_records.id : '',
  report_status_physical: formData?.report_status_physical ? formData?.report_status_physical.id : '',
  report_submission_date: formData?.report_submission_date || null,
  client_acceptance_date: formData?.client_acceptance_date || null,
  remarks_records: formData?.remarks_records || '',
  remarks_physical: formData?.remarks_physical || '',
  assets: formData?.assets?.map((asset) => ({
    asset_type: typeof asset.asset_type === 'object' ? asset.asset_type.id : asset.asset_type,
    asset_id: asset.asset_id,
  })),
  reps: formData?.reps?.map((rep) => ({ user_id: rep.user_id, is_lead: !!rep.is_lead, is_scoped_to_plan: rep.is_scoped_to_plan !== false })),
});



/* Builds the `GET /plans` query string from the toolbar's tab/filter/sort/pagination state. */
export const buildListQuery = ({ tab, filter, sort, page, rowsPerPage }) => {
  const query = { per_page: rowsPerPage, page: page + 1 };
  if (tab !== 'all') query.status = STATUS_IDS[tab];
  if (filter.lessor) query.lessor_id = filter.lessor;
  if (filter.itype) query.inspection_type = filter.itype;
  if (sort.key) {
    query.sort = sort.key === 'start' ? 'planned_start_date' : sort.key === 'end' ? 'planned_end_date' : sort.key;
    query.sort_by = sort.dir === 1 ? 'asc' : 'desc';
  }
  return query;
};

export const buildKpiCards = (kpis = {}) => ([
  { key: 'total_plans', icon: DescriptionOutlinedIcon, label: 'Total Plans', value: kpis?.total_plans?.count ?? 0, sub: kpis?.total_plans?.sub_label, color: PLANNER_COLORS.blue, tab: 'all' },
  { key: 'pending_launch', icon: TrendingUpOutlinedIcon, label: 'Pending Launch', value: kpis?.pending_launch?.count ?? 0, sub: kpis?.pending_launch?.sub_label, color: PLANNER_COLORS.orange, tab: 'Ready to Launch' },
  { key: 'active_projects', icon: FlightTakeoffOutlinedIcon, label: 'Active Projects', value: kpis?.active_projects?.count ?? 0, sub: kpis?.active_projects?.sub_label, color: PLANNER_COLORS.teal, tab: 'Launched' },
  { key: 'closed_tam', icon: CheckCircleOutlineIcon, label: 'Closed (TAM)', value: kpis?.closed_tam?.count ?? 0, sub: kpis?.closed_tam?.sub_label, color: PLANNER_COLORS.green, tab: 'Closed' },
]);

/* Days remaining until a project's planned start; negative once it's past. */
export const daysUntilStart = (date) => moment(date).startOf('day').diff(moment().startOf('day'), 'days');

export const isLaunchingSoon = (plan) => (
  plan?.status?.label === 'Ready to Launch' && daysUntilStart(plan?.planned_start_date) > 0 && daysUntilStart(plan?.planned_start_date) <= 8
);

